import React from "react";
import bg_vid from "../assets/bgvid/videobg.mp4";
import logo from "../assets/logo/Artboard 1 copy 2@4x.png";

function Header() {
  return (
    <header className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        className="absolute top-0 left-0 w-full h-full object-cover object-center transition-all duration-700 ease-in-out"
        style={{ transform: "scale(1.2)" }}
      >
        <source src={bg_vid} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Centered Logo */}
      <div className="relative z-10 flex items-center justify-center">
        <img
          src={logo}
          alt="logo"
          loading="lazy" 
          className="w-64 md:w-80 lg:w-96 drop-shadow-lg"
        />
      </div>
    </header>
  );
}

export default Header;
